import {
  defaultStylingNestedTextElements,
  variantTextStyles,
} from '@components/gassan-ui/Typography/Text'
import { Container, OldText } from '@gassan-ui'
import { cn } from '@lib/cn'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@reach/tabs'
import { FC, useEffect, useRef, useState } from 'react'

type Props = {
  description: string
  title: string
}

const ProductDescription: FC<Props> = ({ title, description }) => {
  const tabParent = useRef<HTMLDivElement>()
  const [linePos, setLinePos] = useState({ left: 0, width: 0 })

  useEffect(() => {
    setIndex(0)
  }, [])

  const setIndex = (index: number) => {
    setTimeout(() => {
      const activeTab = tabParent?.current?.children[index] as HTMLElement
      activeTab &&
        setLinePos({
          left: activeTab.offsetLeft,
          width: activeTab.offsetWidth,
        })
    }, 20)
  }
  return (
    <Container mt={{ _: '2.5rem', small: '4rem', large: '3rem' }}>
      <Tabs onChange={() => null}>
        <TabList ref={tabParent} className={cn('relative flex w-full border-b border-[#E6E6E6]')}>
          <Tab
            className={cn(
              defaultStylingNestedTextElements,
              variantTextStyles['regular'],
              'mr-8 py-2 pb-4 font-normal text-[#808080] transition-colors duration-100',
              'sm:mr-16 sm:py-2 sm:pb-8',
              'lg:mr-14',
              'focus:outline-none',
              'data-[selected]:font-bold data-[selected]:text-[#333333]',
            )}
            data-variant="regular"
          >
            {title}
          </Tab>
          <span
            className="absolute bottom-0 block h-[2px] bg-[#333333] transition-all"
            style={{
              width: linePos.width + 'px',
              left: linePos.left + 'px',
              transitionDuration: '0.15s',
              transitionDelay: '0.05s',
            }}
          />
        </TabList>

        <TabPanels>
          <TabPanel className="focus:outline-none">
            <div
              className={cn(
                'min-h-[400px] max-w-[880px] columns-1 pt-8',
                'sm:gap-x-8 sm:pt-16',
                'lg:gap-x-20 lg:pt-20',
              )}
              style={{
                columns: description && description.length > 600 ? 2 : 1,
              }}
            >
              {description && (
                <OldText
                  style={{ whiteSpace: 'pre-line' }}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  )
}

export default ProductDescription
